import { CONTINENT } from "@/contants";
import { FifaRankingContent } from "../FifaRanking";
import { useEffect, useState } from "react";
import { Image, Link } from "@/lib/target";
import StandingService from "@/services/standingService";
import ADD from "@/assets/images/Add.svg";
import SUBTRACT from "@/assets/images/Subtract.svg";
const StandingFifaFilter = ({continent, slug, type}) => {
  let hideHeader = true;

  if (continent === '' || !continent) {
    hideHeader = false;
    continent = 'the-gioi';
  }
  
  if (slug === undefined && type === 1) {
    slug = 'nam';
  }

  if (slug === undefined && type === 2) {
    slug = 'nu';
  }
  
  const [activeTabList, setActiveTabList] = useState(continent);
  const [data, setData] = useState([]);
  const [visibleItems, setVisibleItems] = useState(20);
  
  useEffect(() => {
    const fetchData = async () => {
      if (activeTabList) {
        try {
          const {data} = await StandingService.getFifaRanking(type);
          setData(data);
        } catch (error) {
          console.error("Error fetching standings:", error);
        }
      }
    };
    fetchData();
  }, []);  

  useEffect(() => {
    setVisibleItems(20);
  },[activeTabList])
  

  const [isOpen, setIsOpen] = useState(false);
  const activeClass = `bg-button-blue-bet @lg:bg-transparent text-white @lg:text-button-blue-bet px-1 @lg:p-0 py-1 rounded`;
  const activeMdClass = `font-semibold relative @lg:before:absolute before:left-0 before:h-0.5 before:-bottom-1 before:w-full before:bg-button-blue-bet z-1`;
  return (
    <div className="standing-list rounded w-full mx-auto @md:px-2 !text-xxs @md:!text-xs">

      <ul id="tabs" className={`h-9 hidden  ${hideHeader ? '@md:hidden' : '@md:flex'} w-full text-xs z-10 px-2`}>
        {CONTINENT.map((item, index) => (
          <li key={index} className="flex items-center justify-center">
            <Link  
              onClick={(e) => {
                e.preventDefault()
                setActiveTabList(item.slug)                
                }}
              key={item.id}
              className={`cursor-pointer text-gray-800 ${ activeTabList === item.slug ? 'font-semibold relative before:absolute before:left-0 before:h-0.5 before:-bottom-1 before:w-full before:bg-button-blue-bet z-1' : '' }`}
              >
              {item.vn}
            </Link>
            <div className={`mx-4 pb-1 h-4`}></div>
          </li>
        ))}
      </ul>
      <div className={` ${hideHeader ? 'hidden' : '@md:hidden'}`}>
        <div className={`bg-button-blue-bet w-full rounded-lg my-2`}>
          <div className={`relative text-xs border-b border-transparent z-2 bg-white rounded justify-between overflow-hidden transition-all duration-500 ${isOpen ? 'shadow h-28 w-full !overflow-y-scroll @lg:!overflow-hidden' : 'h-6 @lg:h-8 w-5/6'}`}>
            <ul id="tabs" className="absolute h-28 flex flex-wrap pr-8 pl-2 w-full @xl:w-[980px]">
              {CONTINENT.slice(0, 20).map((item, index) => (
                <li className="flex items-center justify-center h-6 @lg:h-8 text-xxs @lg:text-xs">
                  <Link  
                    onClick={(e) => {
                      e.preventDefault()
                      setActiveTabList(item.slug)                
                      }}
                    key={item.id}
                    className={`cursor-pointer text-gray-800 ${activeMdClass} ${activeClass}`}
                  >
                    {item.name || item.vn}
                  </Link>
                  <div className={`mx-1.5 @lg:mx-3 pb-1 h-4 border-solid border-l`}></div>
                </li>
              ))}
            </ul>
            <div className="absolute w-6 h-6 @lg:w-8 @lg:h-8 top-0 right-0 bg-white flex items-center justify-center">
              <button className="" onClick={() => setIsOpen(!isOpen)}>
                {isOpen ? <Image alt="Net88" src={SUBTRACT}/> : <Image alt="Net88" src={ADD} />}
              </button>
          </div>
          </div>
        </div>
      </div>
      <div id="tab-contents">
        <FifaRankingContent 
          data={data} 
          continent={activeTabList} 
          visibleItems={visibleItems} 
          setVisibleItems={setVisibleItems}
          />
      </div>
    </div>
  );
}

const StandingFifaMenFilter = ({league}) => {
  return <StandingFifaFilter continent={league} slug="nam" type={1} />
}
const StandingFifaWomenFilter = ({league}) => {
  return <StandingFifaFilter continent={league} slug="nu" type={2} />
}

export {StandingFifaMenFilter, StandingFifaWomenFilter};